import { Component, ViewChild, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MdDialog, MdDialogRef } from '@angular/material';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { TranslateService, LangChangeEvent } from 'ng2-translate';
import { HttpService } from '../../shared/services/http.service';
import { SessionHandler } from '../../shared/services/session-handler.service';
import { CommonService } from '../../shared/services/common.service';
import { dashboardResultService } from '../../dashboardResultService';
import { dialogComponent } from '../../dialog/dialog.component';
import { Location } from '@angular/common'
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'trade-details',
  template: require('./details.component.html'),
  styles: [require('./details.component.scss')]
})
export class DetailsComponent implements OnInit, OnDestroy {
  userData: any;
  isAdmin: boolean = false;
  userRole: any;
  tradePartnerId: any;
  soId: any;
  dialogRef: any;
  trDetails: any;
  // ... other properties unchanged ...
  uploadedDocList: any = [];
  temp: any = [];
  // language subscriptions
  private langSub: Subscription;
  private commonLangSub: Subscription;
showingMediaErrorMsg: string = '';
showingmediaError: boolean = false;


  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private http: HttpService,
    private serverResultsService: dashboardResultService,
    private sessionHandler: SessionHandler,
    public dialog: MdDialog,
    private commonService: CommonService,
    private translate: TranslateService,
    private location: Location,
    private sanitizer: DomSanitizer,
    private cd: ChangeDetectorRef
  ) {
    if (this.http.checkSession()) {
      this.soId = this.activatedRoute.snapshot.paramMap.get('id');
      this.userData = JSON.parse(this.sessionHandler.getItem('loginData') || '{}');
      if (this.userData && this.userData.role && this.userData.role.length > 0) {
        if (this.userData.role.includes('ADMIN')) {
          this.isAdmin = true;
        }
        this.userRole = this.userData.role.join();
        if (this.userData.role.includes('TRADE_PARTNER')) {
          this.tradePartnerId = this.userData.tradePartnerId;
        } else {
          this.tradePartnerId = this.userData.tradePartnerId;
        }
      }
    } else {
      this.http.showSessionError();
    }

    // Restore saved language at construction (so pipes and services start with the right language)
    try {
      const savedLang = localStorage.getItem('appLanguage');
      if (savedLang) {
        this.translate.use(savedLang);
      } else {
        // fallback to English if not present
        this.translate.setDefaultLang('English');
        this.translate.use('English');
        localStorage.setItem('appLanguage','English');
      }
    } catch (e) {
      console.warn('Language init error (details component)', e);
    }

    // subscribe to app-level language change to update this component
    this.commonLangSub = this.commonService.langChange.subscribe((lang: any) => {
      if (lang) {
        try { this.translate.use(lang); } catch (err) { console.warn(err); }
        // run change detection to update template immediately
        try { this.cd.detectChanges(); } catch (err) {}
      }
    });

    // in case translate triggers onLangChange
    this.langSub = this.translate.onLangChange.subscribe((evt: LangChangeEvent) => {
      try { this.cd.detectChanges(); } catch (err) {}
    });
  }

  ngOnInit() {
    this.getTRData();
  }

  ngOnDestroy() {
    if (this.langSub) {
      try { this.langSub.unsubscribe(); } catch (e) {}
    }
    if (this.commonLangSub) {
      try { this.commonLangSub.unsubscribe(); } catch (e) {}
    }
  }

  public getTRData() {
    this.http.getRequest('serviceOrder/v1/getServiceOrder?orderId=' + this.soId)
      .subscribe(
        (res: any) => {
          this.http.onEnd();
          this.trDetails = res.serviceOrderDto;
          console.log(this.trDetails);

          if (this.trDetails.documents && this.trDetails.returnDocs != null) {
            let postData = {
              "transactionId": this.trDetails.soRequestOrderId
            };
            this.getServicedocDoc(postData);
          }
        },
        err => {
          if (err && err.status != 0) {
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = err;
          }
          this.http.onEnd();
        }
      );
  }

  getServicedocDoc(data) {
    this.http.downloadPostRequest('document/downloadDocument', data).subscribe(
      res => {
        this.sanitizeUrl(res['data'])
        this.http.onEnd();
      },
      err => {
        this.showingMediaErrorMsg = "error in fetch image data";
        this.showingmediaError = true;
        this.http.onEnd();
      }
    );
  }

  sanitizeUrl(data) {
    this.uploadedDocList = data;
  }

  navigateDocLink(docUrl) {
    this.dialogRef = null;
    this.dialogRef = this.dialog.open(ViewDetailDialog);
    this.dialogRef.componentInstance.urlList = docUrl;
    this.http.onEnd();
  }

  back() {
    this.location.back();
  }
}

/* ViewDetailDialog stays the same - no changes required there */


// this.dialogRef=null;
//     const dialogConfig = new MatDialogConfig();
//     dialogConfig.data = message;
//     this.dialogRef = this.matDialog.open(MessageDialogComponent, dialogConfig);

//=====================================================================

@Component({
  selector: 'view-dialog',
  template: require('./view-dialog.component.html'),
  providers: [HttpService, SessionHandler]
})
export class ViewDetailDialog {
  //url: string = "https://storage.googleapis.com/kitchenaid-web-return-dev.appspot.com/ReturnUploadedDocs/challan_receipt.pdf";
  urlSafe: SafeResourceUrl;
  urlList: any = [];
  safeUrlList: any = [];
  constructor(public dialog: MdDialog, private commonService: CommonService, public sanitizer: DomSanitizer) { }
  ngOnInit(): void {
    //this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
  }

  public fullView(docUrl) {
    window.open(docUrl, "_blank");
  }

  public closeDialog() {
    this.dialog.closeAll();
  }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/icb/detail/details.component.ts